<!--
  File name: ExportGraph.vue
  Program Description:
    - This component is used as the template of the Reports Generation Chart
    that can be exported as a PDF.
    - When accessed, it renders the NPC Logo, title, exported date, and the chart.
-->
<template>
  <v-container>
    <v-row
      v-for="item, i in items"
      :key="i"
      class="export-graph"
    >
      <v-col style="display: flex; align-items: center; flex-direction: column;">
        <h3
          :style="{
            marginTop: i === 0 ? '120px' : '140px',
            textAlign: 'center',
          }"
        >
          {{ title[i] }}
        </h3>
        <Chart
          :chart-type="isPie ? 'pie' : 'bar'"
          :chart-data="item"
          :chart-options="chartOptions"
          :chart-style="style"
        />
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import Chart from '@/components/exports/charts/Chart.vue'
import graphOptions from '@/meta/graphOptions'
import exportMixin from '@/mixins/exportMixin'
export default {
  name: 'ExportGraph',
  components: {
    Chart
  },
  mixins: [exportMixin],
  props: {
    items: {
      type: [Array, Object],
      default: undefined
    },
    isPie: {
      type: Boolean,
      default: false
    },
    isAsir: {
      type: Boolean,
      default: false
    },
    title: {
      type: Array,
      default: () => ([''])
    },
    reportTitle: {
      type: String,
      default: ''
    }
  },
  data: () => ({
    style: {
      height: '500px',
      marginTop: '2rem',
      width: '1000px'
    }
  }),
  computed: {
    currentDate () {
      return new Date().toLocaleDateString()
    },
    graphOptions () {
      return (type, option) => graphOptions(type)[`${option}`]
    },
    chartOptions () {
      const type = this.isAsir ? 'exportASIR' : 'exportPDBNF'
      const option = this.isPie ? 'pieOptions' : 'barOptions'
      return this.graphOptions(type, option)
    }
  },
  methods: {
    // export the component as pdf
    async exportToPDF (filename) {
      await this.exportAsPDF(filename, this.$el)
    }
  }
}
</script>
